import { defineStore, storeToRefs } from 'pinia'

import api from '@/api/api'
import API from '@/api/apiUrls'
import { ref } from 'vue'
import { useSpeckleAuthStore } from '@haskoning/vue-speckle'
import type { GTLPSectionVisualisation } from '@haskoning/geoprofile-visualization'

export const useSectionVisualisationStore = defineStore('sectionVisualization', () => {
  const currentItem = ref<GTLPSectionVisualisation | null>(null)

  const writeLoading = ref<boolean>(false)
  const boreholeWidthScaling = ref<number>(100)

  const exportToSpeckleDialog = ref<boolean>(false)

  const getVisualizationData = async (dikeProfileId: number) => {
    const speckleAuthStore = useSpeckleAuthStore()

    const { token } = storeToRefs(speckleAuthStore)

    if (token.value) {
      const payload = {
        token: token.value
      }

      const url = API.SPECKLE.VISUALIZATION_SPECKLE.GET_GI_VISUALIZATION_DATA(dikeProfileId)

      const { data } = await api.post(url, payload)
      currentItem.value = data && data !== '{}' ? JSON.parse(data) : null
    }
  }
  return {
    currentItem,
    boreholeWidthScaling,
    writeLoading,
    exportToSpeckleDialog,
    getVisualizationData
  }
})
